import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle as circle } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ExhibitorCategories = ({ categories }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
    const [ main,  setMain ]  = useState([]);
    const [ addon, setAddon ] = useState([]);
    const [ admin, setAdmin ] = useState([]);

    useEffect(() => {
		if(!categories) return;

        let main  = [];
        let addon = [];
        let admin = [];

        categories.forEach(item => {
            switch(item.type) {
                case 'admin':
                    admin.push(item);
                    break;
                case 'addon':
                    addon.push(item);
                    break;
                default:
                    if(!item.is_folder) main.push(item);
                    break;
            }
        });

        main.sort((a, b) => a.name[lang].localeCompare(b.name[lang]))
        addon.sort((a, b) => a.name[lang].localeCompare(b.name[lang]))
        admin.sort((a, b) => a.name[lang].localeCompare(b.name[lang]))

        setMain(main);
        setAddon(addon);
        setAdmin(admin);

    }, [ categories, lang ]);

    if(!main.length && !addon.length && !admin.length) return null;

	return (
		<div className='Exhibitor-left'>
            <h2>{t('exhibitor.categories')}</h2>

            {main.length > 0 && <div>
                {main.map(item => (
                    <span className='category' key={item._id}>
                        <FontAwesomeIcon icon={circle} size='2xs' className='icon'/>
                        {item.name[lang]}
                    </span>
                ))}
            </div>}

            {addon.length > 0 && <div>
                {addon.map(item => (
                    <span className='category' key={item._id}>
                        <FontAwesomeIcon icon={circle} size='2xs' className='icon' style={{color: 'var(--addon-color)'}}/>
                        {item.name[lang]}
                    </span>
                ))}
            </div>}

            {admin.length > 0 && <div>
                {admin.map(item => (
                    <span className='category' key={item._id}>
                        <FontAwesomeIcon icon={circle} size='2xs' className='icon' style={{color: 'var(--admin-color)'}}/>
                        {item.name[lang]}
                    </span>
                ))}
            </div>}
            
		</div>
	);
};

ExhibitorCategories.propTypes = {
    categories: PropTypes.array.isRequired,
};

export default ExhibitorCategories;
